import {
  listRow,
} from '@standard-angular-utilities/shared-components';
import { MatDialog } from '@angular/material/dialog';
import {
  Component,
  inject,
  ViewChild,
} from '@angular/core';
import { TimelogSheet } from 'TimelogDataTypes';

import { TimelogSheetService } from 'TimelogServices/timelog-sheet-service';
import { MatButtonModule } from '@angular/material/button';
import { TimelogSheetDialogComponent } from '../../Dialogs/timelog-sheet-dialog/timelog-sheet-dialog.component';
import { LogService } from 'BaseServices/log-service';
import { UserService } from 'BaseServices/user-service';
import { LogDTO, LogType } from 'BaseDataTypes';
import { LogHelperService } from 'BaseServices/log-helper.service';
import { BaseListPageComponent } from 'src/app/BasePages/base-list-page/base-list-page.component';

@Component({
  selector: 'app-timelog-sheets-view',
  imports: [MatButtonModule, BaseListPageComponent],
  templateUrl: './timelog-sheets-view.component.html',
  styleUrls: [
    '../../../../../../src/app/general-styles/pages.css',
    './timelog-sheets-view.component.css',
  ],
})
export class TimelogSheetsViewComponent {
  @ViewChild('baseListPage')
  baseListPage!: BaseListPageComponent<TimelogSheet>;
  timelogHeaderList: string[] = ['Navn', 'Sheet ID'];
  headerList: string[] = this.timelogHeaderList;
  timelogSheets: TimelogSheet[] = [];
  logHeaderList: string[];

  readonly dialog = inject(MatDialog);

  constructor(
    private timelogSheetService: TimelogSheetService,
    private logService: LogService,
    private userService: UserService,
    private logHelper: LogHelperService
  ) {
    this.logHeaderList = this.logService.getLogHeaders('Sheet');
  }

  ngOnInit() {
    this.updateListWithTimelogSheets();
  }

  sheetClicked = (sheet?: TimelogSheet) => {
    let data = sheet ?? { id: 0, sheetName: '', sheetId: '', userId: 0 };
    let dialogref = this.dialog.open(TimelogSheetDialogComponent, {
      data: { data: [data] },
    });
    dialogref.afterClosed().subscribe((result) => {
      if (result == true) {
        this.updateListWithTimelogSheets();
      }
    });
  };

  /**
   * Function which switches the list between timelog sheets and the event log.
   */
  switchDataInList = (isHistory: boolean) => {
    if (isHistory) {
      this.updateListWithTimelogSheets();
    } else {
      this.updateListWithLogData();
    }
  };

  updateListWithLogData() {
    this.logHelper.updateLogList(
      LogType.TimelogSheets,
      this.getTimelogSheetsId.bind(this),
      (data) => this.baseListPage.UpdateLogListData(data)
    );
  }

  getTimelogSheetsId(id: number): string {
    return (
      this.timelogSheets.find((t) => t.id === id)?.sheetName || id.toString()
    );
  }

  updateListWithTimelogSheets() {
    this.timelogSheetService.getSheets().subscribe((result) => {
      let tempList: listRow<TimelogSheet>[] = [];
      result.forEach((sheet) => {
        tempList.push({
          object: sheet,
          id: sheet.id,
          data: [sheet.sheetName, sheet.sheetId],
        });
      });
      this.timelogSheets = result;
      this.headerList = this.timelogHeaderList;
      this.baseListPage.UpdateListData(tempList);
    });
  }
}
